import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Skeleton } from "antd";
import { GiSofa } from "react-icons/gi";
import { Pagination, Autoplay } from "swiper/modules";

const MainPageCarousal = ({ MainBanners, SkeletonLoad }) => {
  const skeletonArray = Array.from({ length: 1 }, (_, index) => index);
  return (
    <div className="w-full">
      <div className="h-[50vh] min-h-[300px] max-h-[520px] w-full">
        <Swiper
          pagination={true}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper h-full w-full"
        >
          {SkeletonLoad ? (
            <div className="h-full w-full">
              {skeletonArray.map((index) => (
                <div key={index}>
                  <Skeleton.Node
                    active={true}
                    style={{ height: "100%", width: "100%" }}
                  >
                    <div className="flex justify-center">
                      <GiSofa style={{ fontSize: 300, color: "#bfbfbf" }} />
                    </div>
                  </Skeleton.Node>
                </div>
              ))}
            </div>
          ) : (
            MainBanners.map((el, i) => {
              if (el.device === "1") {
                return (
                  <SwiperSlide key={i} className="h-full w-full">
                    <div className="h-full w-full">
                      <div className="relative h-full w-full">
                        <img
                          src={
                            process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.path
                          }
                          alt="Image is not available"
                          className="h-full w-full object-cover"
                        />
                        {/* <button className="bg-[#000] text-white font-normal text-2xl tracking-wide p-3 px-9 rounded-full absolute bottom-[60px] left-[88.5px]">Order Now</button> */}
                      </div>
                    </div>
                    {/* <img
            src={process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.path}
            alt="" 
            className="object-cover"
          /> */}
                  </SwiperSlide>
                );
              } else {
                return null;
              }
            })
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default MainPageCarousal;
